// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__N36ka","Menu":"Header_Menu__7JWyV","MenuToggled":"Header_MenuToggled__WeZLM","swing-in":"Header_swing-in__eYMby","MenuWrapper":"Header_MenuWrapper__VDmCs"};